import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';
import { Router,ActivatedRoute, ParamMap } from '@angular/router';
import  * as moment from 'moment-timezone';
import  * as moment1 from 'moment';
@Component({
    selector: 'app-keywords',
    templateUrl: './activeadvertisements.component.html',
  providers: [ SharedService,PopupSegmentComponent]
 
})
export class ActiveAdvertisementsComponent implements OnInit {

data=[];
i=1;
page : number =1;
itemsTotalAdv : number =0;
enable = [];
objLoaderStatus: boolean = false;
blockedFlag : boolean = false;
searchAdvText = '';
message = '';
segmentArray =[];
errormessage = '';
charFlag :boolean = false;
userId : number;
name = "";
imgType =[];
currentdate: number;
  expirein = [];
 genderArray = [];
     ageArray = [];
     genderString ='';
     ageGroupString = '';
     timezomeGuess
      column = "";
  numberColumn : number =0;
  order : string ="ASC";
  sortingOrder = [];
    constructor(private localstorage: LocalStorage,
     private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private shareService: SharedService,
    private PopupSegment: PopupSegmentComponent, 
    private dialogService:DialogService,
    private router: Router,private route: ActivatedRoute) {
      this.timezomeGuess = moment.tz.guess();
    var i=0;
  for(i=0;i<25;i++){
    this.sortingOrder[i] = true;
  }
    
    }

    convertDaysHour2(campaignDuration: number, value: number) {
          console.log("campaignDuration"+campaignDuration)
          var dateFormat;
          var dateTime;
          var getDate = new Date(value);
          var now;
          dateFormat = getDate.toString()
          dateFormat = moment1.utc(getDate).format('YYYY-MM-DD');
          dateTime = moment1(dateFormat + ' ' + campaignDuration, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
          now = new Date();
          now = moment1(now).format('YYYY-MM-DD HH:mm');
          console.log("dateTime"+dateTime)
          console.log("now"+now)
          let getExpiryDate= moment(dateTime,"YYYY-MM-DD HH:mm:ss").diff(moment(now,"YYYY-MM-DD HH:mm:ss"));
          let seconds = Math.floor(getExpiryDate / 1000);
            let minute = Math.floor(seconds / 60);
            seconds = seconds % 60;
            let  hour = Math.floor(minute / 60);
            minute = minute % 60;
            let day = Math.floor(hour / 24);
            hour = hour % 24;
            return {
            day: day,
            hour: hour,
            minute: minute,
            seconds: seconds
    };
      }

    ngOnInit() {
       this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
      var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 
    });

    this.currentdate =  Date.now();

 
this.localstorage.setStorage("country",'');

       var i=0;
         var token = this.localstorage.getStorage("token");
         this.loaderService.displayLoader(true);
  this.shareService.CallDatawithToken("admin/getAllActiveCampaigns/?currentSize=25&timeZone="+this.timezomeGuess+"&sortColumn=name&sortOrder=ASC", null, token).subscribe((result) => {
  
  if(result.data){
     console.log(result);
this.data = result.data;
for (i=0;i<this.data.length;i++){
if(this.data[i].type == "IMG"){
 this.data[i].type = "Image";
 this.imgType[this.data[i].id] = true;
}
else{
  this.data[i].type = "Text";
 this.imgType[this.data[i].id] = false;
}
console.log("start date");
console.log(this.formatDateFornew(new Date(this.data[i].startAt)));
           
 this.data[i].startAtDate=this.formatDateFornew(new Date(this.data[i].startAt));
            this.data[i].endAtDate=this.formatDateFornew(this.convertUTCDateToLocalDate(new Date(this.data[i].endAt)).getTime());

this.data[i].startTime = this.data[i].campaignDuration[0].startTime;
this.data[i].endTime = this.data[i].campaignDuration[0].endTime;
if(this.data[i].endTime == 23.59){
 this.data[i].endTime = 24; 
}
this.data[i].endDiffDate = this.formatDateFordiff(new Date(this.data[i].endAt));
this.data[i].startDiffDate = this.formatDateFordiff(new Date(this.data[i].startAt));
this.data[i].diffDays = this.calculateDiff(this.data[i].startDiffDate,this.data[i].endDiffDate);
this.data[i].duration = this.data[i].endTime - this.data[i].startTime;
if(result.data[i].endAt){
            var getResult =  this.convertDaysHour2(this.data[i].campaignDuration[0].endTime, this.data[i].endAt); 
             let day = getResult.day;
             let hour = getResult.hour;
             let minute = getResult.minute;
             let seconds = getResult.seconds;
             this.expirein[i] =[day,hour,minute,seconds];
           }
          
          this.data[i].expiretime=this.expirein[i];

 
                 this.data[i].startTime = this.data[i].startTime + ":00";
              this.data[i].endTime = this.data[i].endTime + ":00"; 

            }
            console.log(this.data);
this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
   this.loaderService.displayLoader(false);
  
}

     });
    }

 calculateDiff( date1, date2 ) {
      // var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
      // var firstDate = new Date(str1);
      // var secondDate = new Date(str2);
      // var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime())/(oneDay)));
      // return diffDays;
      let dt1 = new Date(date1);
      let dt2 = new Date(date2);
      let diff=Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) ) /(1000 * 60 * 60 * 24));
      return diff;
}
    getExpiryTimeString(d,h,m,s) {
            return d+"D "+h+"H "+m+"M "+s+"S";
    }

formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth()),
            day = '' + d.getDate(),
            year = d.getFullYear();

            // console.log(day);
            //console.log(date.toString("MMM dd"));
        var monthsOfYear = ["Jan","Feb","March","April","May","June","July","Aug",
						"Sep","October","Nov","Dec"];
        if (month.length < 2) month = monthsOfYear[month];
        if (day.length < 2) day = '0' + day;
         return day +" "+month+", "+year;
        //return [year, month, day].join('-');
    }

convertIntoExpiretime(startAt,endAt,endTime,startTime) {
      if(startAt==null || startAt=="") {
            return "Pending";
          }
          startAt=this.convertUTCDateToLocalDate(new Date(startAt)).getTime();
          endAt=this.convertUTCDateToLocalDate(new Date(endAt)).getTime();
         let days=this.calculateDiff(startAt,endAt);
         let getExpiryDate= (startAt-this.currentdate);
         let startdate=this.formatDate(startAt);
 var currentdate = new Date();

          console.log(startdate);
          console.log(this.formatDate(endAt));

         let current=this.formatDate(this.currentdate);

          if(startdate < current){
 startAt=this.currentdate;
         startdate=current;
         days=this.calculateDiff(startAt,endAt);
 }

         if(startdate==current && days==0){
            if(currentdate.getHours()>startTime && 
           currentdate.getHours() < endTime   ){
            return this.getExpiryTimeString(0, endTime - currentdate.getHours() -1, (60 - currentdate.getMinutes()), (60 - currentdate.getSeconds()));
             }
             else if(currentdate.getHours() < startTime){
   
 return this.getExpiryTimeString(0, endTime - startTime, 0, 0);
  
             }
             else if(currentdate.getHours() == startTime){
 return this.getExpiryTimeString(0, endTime - startTime -1, (60 - currentdate.getMinutes()), (60 - currentdate.getSeconds()));

             }
             else{
return "Campaign Expired";
             }
         } else {
            if(startdate > current){
              return this.getExpiryTimeString(days+1,0,0,0);
           } else {
            
            if((currentdate.getHours()>startTime && 
           currentdate.getHours() < endTime) ){
              
             return this.getExpiryTimeString(days,endTime-currentdate.getHours() -1,(60-currentdate.getMinutes()),(60-currentdate.getSeconds()));
               
        }
           else if(currentdate.getHours() < startTime){

 return this.getExpiryTimeString(days, endTime - startTime, 0, 0);

           }
     else if(currentdate.getHours() == startTime){
 return this.getExpiryTimeString(days, endTime - startTime -1, (60 - currentdate.getMinutes()), (60 - currentdate.getSeconds()));

            }
            else if(days >0 ){
               
                if((currentdate.getHours()>startTime && 
           currentdate.getHours() >= endTime)){
return this.getExpiryTimeString(days, 0, 0, 0);

           }
            }
           }
             // this.campaign.expiretime=this.getExpiryTimeString(this.someRange,0,0,0);
         }
    }
 formatDateFornew(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [day, month, year].join('/');
    }

     formatDateFordiff(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }


      convertUTCDateToLocalDate(date) {
    var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);

    var offset = date.getTimezoneOffset() / 60;
    var hours = date.getHours();

    newDate.setHours(hours - offset);

    return newDate;   
}
    
nextAdver(text,id,order,event){
  var order;
  if(text){
  this.column = text;
}

if(this.column == ""){
  this.column = "name";
}
     if(id !== ''){
  this.numberColumn = id;
}

 var i=0;
  for(i=0;i<25;i++){
 
    if(this.numberColumn != i ){
    this.sortingOrder[i] = true;
  }
  }
if(order){
  this.order = order;
}
  
  

  if(this.order == 'DESC'){
this.sortingOrder[this.numberColumn] = false;
  }
  else{
this.sortingOrder[this.numberColumn] = true;
  }
    var j=0;
    this.page = event;
         var token = this.localstorage.getStorage("token");

    this.itemsTotalAdv =0;
  this.data =[];
   var i=0;
            this.errormessage ="";
   this.loaderService.displayLoader(true);

 this.shareService.CallDatawithToken("admin/getAllActiveCampaigns/?currentSize=25&currentPage="+event+"&timeZone="+this.timezomeGuess+"&sortColumn="+this.column+"&sortOrder="+this.order, null, token).subscribe((result) => {
  
  if(result.data){
     console.log(result.data);
this.data = result.data;
for (i=0;i<this.data.length;i++){
if(this.data[i].type == "IMG"){
 this.data[i].type = "Image";
 this.imgType[this.data[i].id] = true;
}
else{
  this.data[i].type = "Text";
 this.imgType[this.data[i].id] = false;
}
console.log("start date");
console.log(this.formatDateFornew(new Date(this.data[i].startAt)));
           this.data[i].startAtDate=this.formatDateFornew(new Date(this.data[i].startAt));
            this.data[i].endAtDate=this.formatDateFornew(this.convertUTCDateToLocalDate(new Date(this.data[i].endAt)).getTime());
this.data[i].startTime = this.data[i].campaignDuration[0].startTime ;
this.data[i].endTime = this.data[i].campaignDuration[0].endTime;
if(this.data[i].endTime == 23.59){
 this.data[i].endTime = 24 ; 
}

this.data[i].endDiffDate = this.formatDateFordiff(this.convertUTCDateToLocalDate(new Date(this.data[i].endAt)).getTime());
this.data[i].startDiffDate = this.formatDateFordiff(this.convertUTCDateToLocalDate(new Date(this.data[i].startAt)).getTime());
this.data[i].duration = this.data[i].endTime - this.data[i].startTime;
this.data[i].diffDays = this.calculateDiff(this.data[i].startDiffDate,this.data[i].endDiffDate);

if(result.data[i].endAt){
            var getResult =  this.convertDaysHour2(this.data[i].campaignDuration[0].endTime, this.data[i].endAt); 
             let day = getResult.day;
             let hour = getResult.hour;
             let minute = getResult.minute;
             let seconds = getResult.seconds;
             this.expirein[i] =[day,hour,minute,seconds];
           }
          this.data[i].expiretime=this.expirein[i];
  
              this.data[i].startTime = this.data[i].startTime + ":00";
              this.data[i].endTime = this.data[i].endTime + ":00";
  
}

this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
   this.loaderService.displayLoader(false);
  
}

     });
 
    return event; 
    
        
}





viewSegments(id){
  var i=0;
  var j=0;
     this.segmentArray =[];
  for(i=0;i<this.data.length;i++){
 
    if(this.data[i].id == id){
      console.log(this.data[i].segment);
      if(this.data[i].segments == ''){
        this.message = "No segments for this advertisement";
      }

      else{
             
        this.segmentArray.push(this.data[i].segment);
        this.message = "Information of Segments with this advertisement:";
 
      }
    }
  }


this.showConfirm();

}

viewGender(id){
  var i=0;
  var j=0;
     this.segmentArray =[];
     this.genderArray = [];
     this.ageArray = [];
     this.genderString = '';
  for(i=0;i<this.data.length;i++){
 
    if(this.data[i].id == id){
      if(this.data[i].userGroup == ''){
        this.message = "No target gender audience for this advertisement";
      }

      else{
             for(j=0;j<this.data[i].userGroup.length;j++){
               if(this.data[i].userGroup[j].type == "GENDER"){
                 this.genderArray.push(this.data[i].userGroup[j].name );
                 this.genderString = this.genderArray.join(',');
               }
             }
        this.message = "Target gender audience for this advertisement: " +this.genderString;
 
      }
    }
  }
this.showConfirm();

}

viewAge(id){
  var i=0;
  var j=0;
     this.segmentArray =[];
     this.genderArray = [];
     this.ageArray = [];
     this.ageGroupString = '';
  for(i=0;i<this.data.length;i++){
 
    if(this.data[i].id == id){
    if(this.data[i].userGroup == ''){
        this.message = "No target age group audience for this advertisement";
      }

      else{
             for(j=0;j<this.data[i].userGroup.length;j++){
               if(this.data[i].userGroup[j].type == "AGE_BRACKET"){
                 this.ageArray.push(this.data[i].userGroup[j].name );
                 this.ageGroupString = this.ageArray.join(',');
               }
             }
        this.message = "Target age group audience for this advertisement: " +this.ageGroupString;
 
      }
    }
  }
this.showConfirm();

}

  showConfirm() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Advertisement Information', 
                message:this.message,
              data: this.segmentArray,
              showcancel :false})
                .subscribe((isConfirmed)=>{
                    //We get dialog result
                    
                });
            //We can close dialog calling disposable.unsubscribe();
            //If dialog was not closed manually close it by timeout
        }


deleteActiveAdvertisement(id){
      this.showConfirmDelete();
      this.userId = id; 
 }


showDelete() {
      let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
          title:'Advertiser Information', 
          message:'Active Advertisement Deleted Successfully',
        data: [],
       showcancel :false})
          .subscribe((isConfirmed)=>{
              //We get dialog result
              window.location.reload();
          });
  }

showConfirmDelete(){
        var token = this.localstorage.getStorage("token");

        let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
            title:'Active Advertisement Information', 
            message:'Are you sure you want to delete the active advertisement?',
          data: [],
         showcancel :true})
            .subscribe((isConfirmed)=>{
              if(isConfirmed){
               this.loaderService.displayLoader(true);
        this.shareService.callApiWithToken("admin/deleteCampaign/"+this.userId,{},token).subscribe((result) => {
        if(result.data.status == true){
        this.showDelete();
        // alert("Advertiser deleted successfully");
        //window.location.reload();    }
        }
        this.loaderService.displayLoader(false);
        });
              }
            });

        }


}



// WEBPACK FOOTER //
// ./src/app/admin/layout/activeadvertisements/activeadvertisements.component.ts